import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const ScreenLoader = () => {
  return (
    <Box
      sx={{
        height:"500px",
        width:"100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress size={60} sx={{color:"#3173B1"}} />
    </Box>
  );
};

export default ScreenLoader;
